import type { PartialConfig } from './base';

const production: PartialConfig = {
  backend: {
    base: 'https://k8s.litlingo.com/api/v1',
  },
  documents: {
    base: 'https://gateway.litlingo.com/api/documents',
    socket: 'wss://gateway.litlingo.com/socket',
  },
};

export default production;
